import { FC } from "react";
import { CashActivityDataWithMeta, CashActivityUpdate } from "../types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { addComma } from "../../../../utils";

const CashUpdateActivity: FC<CashActivityDataWithMeta> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as CashActivityUpdate;
  return (
    <>
      <ActivityTitle type={type}>ویرایش نقدی</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="بابت"
          value={activity_.description}
        />
        <ActivityBodyInfo
          type={type}
          title="مبلغ"
          value={addComma(activity_.total_price)}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default CashUpdateActivity;
